import script from "./Snackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=3be86c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be86c18"]])

export default __exports__